import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormBoolean',
    props: {
        value: { type: [Boolean, String] }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const currentValue = computed({
            get() {
                return String(props.value).toLowerCase() === "true";
            },
            set(newValue) {
                emit("input", newValue);
            },
        });
        const label = computed(() => (currentValue.value ? "Yes" : "No"));
        return { __sfc: true, props, emit, currentValue, label };
    }
});
